import { Component, computed, input } from '@angular/core';
import { AssetType } from '../../services/asset-service/types';

@Component({
  selector: 'asset-type-tag',
  templateUrl: './asset-type-tag.html',
  styleUrl: './asset-type-tag.scss',
})
export class AssetTypeTag {
  assetType = input.required<AssetType>();

  readonly typeTagClass = computed(() => {
    const map: Record<AssetType, string> = {
      Dataset: 'dataset',
      'AI Agent': 'agent',
      'AI Tool': 'tool',
      'AI Product': 'product',
    };
    return map[this.assetType()] ?? 'default';
  });
}
